import { Record } from 'immutable';

const InvoiceItemDefaults = {
  type: null,
  name: null,
  value: null,
  value_in_cents: null,
  color: null,
  inventory_record_id: null
};

class InvoiceItem extends Record(InvoiceItemDefaults) {}

export default InvoiceItem;



// WEBPACK FOOTER //
// banquet/models/InvoiceItem.js